import React, { useState } from 'react';
import projectVideo from '../../assets/Video Project.mp4';
import './DancingAnimation.css';

const DancingAnimation = () => {
    const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

    const handleMouseMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setMousePos({
            x: e.clientX - rect.left,
            y: e.clientY - rect.top
        });
    };

    return (
        <div
            className="dancing-split-container"
            onMouseMove={handleMouseMove}
            style={{
                '--mouse-x': `${mousePos.x}px`,
                '--mouse-y': `${mousePos.y}px`
            }}
        >
            {/* The cursor glaze effect layer */}
            <div className="cursor-glaze"></div>

            <div className="dancing-left">
                <div className="phone-mockup">
                    <div className="phone-notch"></div>
                    <div className="phone-screen">
                        <video
                            src={projectVideo}
                            autoPlay
                            loop
                            muted
                            playsInline
                        />
                    </div>
                </div>
            </div>
            <div className="dancing-right">
            </div>

            <div className="jet-assembly">
                {/* The Space Jet */}
                <div className="space-jet">
                    <div className="jet-body"></div>
                    <div className="jet-wing-left"></div>
                    <div className="jet-wing-right"></div>
                    <div className="jet-exhaust"></div>
                </div>
                {/* Tether string */}
                <div className="jet-tether"></div>
                {/* Hanging Paper Poster */}
                <div className="paper-poster">
                    <div className="poster-inner">
                        <div className="poster-date">
                            <span className="date-main">MARCH</span>
                            <span className="date-days">13 & 14</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DancingAnimation;
